import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LogoMark } from "@/components/site/Logo";

export default function Preloader() {
  const [done, setDone] = useState(typeof window !== "undefined" && window.location.hash === "#instant");

  useEffect(() => {
    if (done) return;
    const t = setTimeout(() => setDone(true), 2100);
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  useEffect(() => {
    if (done) document.body.style.overflow = "";
  }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] bg-[#0B132B] grain flex items-center justify-center"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="relative z-10 flex flex-col items-center">
            <LogoMark size={90} animate />
            <div className="mt-6 overflow-hidden">
              <motion.div
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.7, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
                className="flex items-baseline gap-2"
              >
                <span className="font-display text-white text-5xl tracking-tight">OKA</span>
                <span className="font-display italic text-[#8ea2c8] text-5xl">VTC</span>
              </motion.div>
            </div>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.4, delay: 0.4 }}
              className="mt-6 h-px w-40 bg-white/25 origin-left"
            />
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.1 }}
              className="mt-4 text-[10px] tracking-[0.4em] uppercase text-white/40"
            >
              Chauffeur privé · Région lyonnaise
            </motion.span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
